import toast from 'react-hot-toast'

import getEndpoint from '@/helpers/getEndpoint'
import API from '@/services/API'

import { ContactForm } from '../types'

export async function submitContactForm(data: ContactForm) {
  const response = await API.post(getEndpoint('CONTACT_MESSAGE'), {
    formData: {
      contact_message: {
        subject: data.subject,
        body: data.body,
        email: data.email,
        phone: data.phone,
        kind: 'contact_message',
      },
    },
  })

  if (response.status === 'success') {
    toast.success('Sukces! Pomyślnie wysłano formularz kontaktowy.')
  } else {
    toast.error('Wystąpił błąd.')
  }
}
